import has from 'lodash/has'
// array of images urls splitted by scenes, used for preloading
export function imagesUrls (settings) {
  // console.log('settings', settings)
  const res = []
  res.push([
    settings.splash.logo,
    settings.intro.image
  ])

  if (has(settings, 'door.video.thumbUrl')) {
    res.push([
      settings.door.video.thumbUrl
    ])
  }

  for (const showcase of settings.showcases) {
    res.push([showcase.image])
  }

  if (settings.lastScene && settings.lastScene.image) {
    res.push([
      settings.lastScene.image
    ])
  }

  return res
}



// WEBPACK FOOTER //
// ./src/templates/outSide/template/appImages.js